import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

export default function TripadvisorButton({ title, rating, image, url, numberOfReviews, alt }) {
  return (
    <Fragment>
      <div className='title'>
        { title || <FormattedMessage id='tripadvisor_rating' defaultMessage='TripAdvisor Traveler Rating' /> }
      </div>
      <div className='rating-wrap tripadvisor-rating-wrap'>
        <img src={image} alt={alt} />
        <a href={url} target='_blank' className='rating-count'>
          <span>{ numberOfReviews }</span>&nbsp;<FormattedMessage id='reviews' defaultMessage='Reviews' />
        </a>
      </div>
    </Fragment>)
}
